import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';

const client = axios.create();

export { client };
